/**
 * Key prefixes of the queries whose responses carry text the backend words in the language of
 * the request: agent names, descriptions, greetings, input hints, tool names, and the persona
 * sparks the model writes in that language. Their keys do not carry the language, so a language
 * switch invalidates them instead. A new query serving such text adds its prefix here, or keeps
 * showing the previous language until it goes stale.
 */
export const LANGUAGE_DEPENDENT_QUERY_PREFIXES: readonly (readonly string[])[] = [
  /* eslint-disable i18next/no-literal-string -- query keys, not copy */
  ['agent'],
  ['agents'],
  ['most-used-agents'],
  ['springboard-tools'],
  ['tool-categories'],
  ['admin', 'tools'],
  ['admin', 'tool-config'],
  ['persona-spark'],
  ['persona-sparks'],
  /* eslint-enable i18next/no-literal-string */
];
